import { Table } from 'antd';

type Props = {
    data: any;
    columns: any;
    title?: string;
};

const CM0016Table = ({ data, columns, title }: Props) => {
    return (
        <div className="table-top">
            <Table
                columns={columns}
                dataSource={data}
                bordered
                title={() => title}
                pagination={false}
            />
        </div>
    );
};

export default CM0016Table;
